var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_content"},[_c('div',{staticClass:"center"},[_vm._v("您确定要删除任务“"+_vm._s(_vm.curItem.taskName)+"”吗？")])])}
var staticRenderFns = []

export { render, staticRenderFns }